export default __webpack_public_path__ + "static/media/encode_progress.2c28c651.png";